import React from 'react';
import auth from '../../utils/auth';
import { Redirect, StaticContext, RouteComponentProps } from 'react-router';
import DashboardRouter from '../../routers/DashboardRouter';

export interface ProtectedRouteProps extends React.ComponentProps<any> {
  path: string;
  component?: typeof React.Component;
  render?: (props: RouteComponentProps<any, StaticContext, unknown>) => React.ReactNode;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { component: Component, render, ...rest } = props;
  return (
    <DashboardRouter
      {...rest}
      render={renderProps => {
        if (!auth.getCurrentUser()) return <Redirect to="/login" />
        return Component ? <Component {...renderProps} /> : render(renderProps);
      }}
      exact
    />
  )
}

export default ProtectedRoute;
